import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface TestimonialStoryCardProps {
  imageSrc: string;
  imageAlt: string;
  badgeText: string;
  badgeColorClass?: string; // e.g. 'bg-green-500'
  avatarSrc: string;
  name: string;
  locationDate: string;
  metric: string;
  quote: string;
}

export const TestimonialStoryCard: React.FC<TestimonialStoryCardProps> = ({
  imageSrc,
  imageAlt,
  badgeText,
  badgeColorClass = 'bg-wedding-pink',
  avatarSrc,
  name,
  locationDate,
  metric,
  quote,
}) => {
  return (
    <Card className="group h-full flex flex-col bg-white border-gray-200/80 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden">
      <div className="aspect-video bg-gradient-to-br from-pink-200 to-rose-200 relative overflow-hidden shrink-0">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-500"></div>
        <div className="absolute top-4 right-4">
          <div className={`${badgeColorClass} text-white px-2 py-1 rounded-full text-xs font-medium`}>
            {badgeText}
          </div>
        </div>
      </div>
      <CardContent className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <img src={avatarSrc} alt="User" className="h-10 w-10 rounded-full" />
          <div>
            <p className="font-semibold text-wedding-text-title">{name}</p>
            <p className="text-xs text-gray-500">{locationDate}</p>
          </div>
        </div>
        <blockquote className="text-gray-700 text-sm leading-relaxed flex-1">{quote}</blockquote>
        <div className="mt-3">
          <span className="inline-block text-xs font-medium text-wedding-pink bg-wedding-pink/10 rounded-full px-3 py-1">
            {metric}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

